import React from 'react'
import NavLink from 'app/components/util/lgy-nav-link/LgyNavLink'

const NADLSideNav = (canViewRecords, canViewReports) => {
  
  
  return(
  <aside className='sidenav sticky'>
    <ul className='usa-sidenav-list'>
      {canViewRecords && <li>
        <NavLink activeClassName='usa-current' to={`/lgyhub/NADL/records`}>
          Record Maintenance
        </NavLink>
      </li>}
      {canViewReports && <li>
        <NavLink activeClassName='usa-current' to={`/lgyhub/NADL/reports`}>
          Run Reports
        </NavLink>
      </li>}
    </ul>
  </aside >
  )
}


export default NADLSideNav